import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const ServiceOptionsIncluded = ({ data, iconSize }) => {
	const optionItemCls = classnames('service-option-item', {
		small: iconSize === 'small',
	});

	return (
		<div className="common-rate-advisor-service-options-included">
			{data?.map(option => (
				<div className={optionItemCls} key={`includes-${option.icon}`}>
					<div className={`service-option-icon ${option.icon}`} />
					<p
						className="service-option-text"
						// eslint-disable-next-line
						dangerouslySetInnerHTML={{ __html: option.text }}
					/>
				</div>
			))}
		</div>
	);
};

ServiceOptionsIncluded.propTypes = {
	iconSize: PropTypes.oneOf(['small', 'normal']),
	data: PropTypes.array,
};

export default ServiceOptionsIncluded;
